import { ObservableFromFetch } from "../ObservableFromFetch"
import GridData from "./GovPoolModel/GridData"
import { Filter, Sort } from "../GridRequest"

export function PoolGridGetObservable(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }) {
  const requestBody: string = JSON.stringify({
    Filters: {
      Name: filters.find(filter => filter.column === "Name")?.values || [],
      SelectionInterval: filters.find(filter => filter.column === "SelectionInterval")?.values || [],
      SelectionDate: filters.find(filter => filter.column === "SelectionDate")?.values || [],
      DaysToSelect: filters.find(filter => filter.column === "DaysToSelect")?.values || [],
      GroupSize: filters.find(filter => filter.column === "GroupSize")?.values || [],
    },
    PageNumber: pageNumber,
    PageSize: pageSize,
    SortGrid: { SortColumn: sort.column, SortOrder: sort.order.toUpperCase() },
  })

  return ObservableFromFetch<GridData>("GovPool/GetGrid", requestBody)
}
